import { z } from 'zod';
import BaseColumnsContainer from '../../../Packages/block-columns-container';
const BasePropsShape = BaseColumnsContainer.schema.shape.props.unwrap().unwrap().shape;
const ColumnsContainerPropsSchema = z.object({
    style: BaseColumnsContainer.schema.shape.style,
    props: z
        .object(Object.assign(Object.assign({}, BasePropsShape), { columns: z.tuple([
            z.object({ childrenIds: z.array(z.string()) }),
            z.object({ childrenIds: z.array(z.string()) }),
            z.object({ childrenIds: z.array(z.string()) }),
        ]) }))
        .optional()
        .nullable(),
});
export default ColumnsContainerPropsSchema;
//# sourceMappingURL=ColumnsContainerPropsSchema.js.map